"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.configKeys = {
    EXP_API_URL: 'EXP_API_URL',
    SPOTIFY_API_URL: 'SPOTIFY_API_URL',
    PRODUCT_ID: 'PRODUCT_ID',
};
var config = (_a = {},
    _a[exports.configKeys.EXP_API_URL] = '',
    _a[exports.configKeys.SPOTIFY_API_URL] = '',
    _a[exports.configKeys.PRODUCT_ID] = '',
    _a);
exports.setConfig = function (cfg) {
    Object.keys(exports.configKeys).forEach(function (key) {
        config[key] = cfg[key];
    });
};
exports.GRAPH_QL_PATH = '/exp/graph';
exports.default = config;
//# sourceMappingURL=index.js.map